const DEMO_KLINIKUM = 12;
const BERLIN_DEMO_KLINIKUM = 1596;
const SUMMIT_DEMO_DOC_TILES_CARESEEKER_IDS = new Set<number>([
  DEMO_KLINIKUM,
  BERLIN_DEMO_KLINIKUM,
]);

/**
 * Summit demo-only tiles (DEV-20018). Visible in Demo and Preprod for specific careseeker accounts.
 */
export function isSummitDemoAdditionalDocTilesEnabled(
  careseekerId: number | null | undefined,
): boolean {
  if (careseekerId == null) {
    return false;
  }
  if (!SUMMIT_DEMO_DOC_TILES_CARESEEKER_IDS.has(careseekerId)) {
    return false;
  }

  return true;
}
